var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 2.49999C14.3859 2.28112 14.6457 2.1075 14.9317 1.98905C15.2176 1.8706 15.5241 1.80963 15.8337 1.80963C16.1432 1.80963 16.4497 1.8706 16.7357 1.98905C17.0216 2.1075 17.2815 2.28112 17.5003 2.49999C17.7192 2.71886 17.8928 2.97869 18.0113 3.26466C18.1297 3.55063 18.1907 3.85713 18.1907 4.16665C18.1907 4.47618 18.1297 4.78268 18.0113 5.06865C17.8928 5.35461 17.7192 5.61445 17.5003 5.83332L6.25033 17.0833L1.66699 18.3333L2.91699 13.75L14.167 2.49999Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.4ed549796d99e8f5b667a5a6cd34b072.svg";
export { ForwardRef as ReactComponent };